import React from "react";
import { Link, useLocation } from "react-router-dom";
import { VHU_BID_OFFERS_PAGE, VHU_EXPIRED_LOTS_PAGE, VHU_LOTS_PAGE } from "../../routes/routeConstants";

const navigationItems = [
  { to: VHU_LOTS_PAGE, icon: "ri-stack-line", label: "Lots", hint: "Préparer et publier" },
  { to: VHU_BID_OFFERS_PAGE, icon: "ri-auction-line", label: "Offres", hint: "Comparer et décider" },
  { to: VHU_EXPIRED_LOTS_PAGE, icon: "ri-archive-line", label: "Archives", hint: "Consulter les clôturées" },
];

function VhuPageGuide({ eyebrow = "Gestion VHU", title, description, steps = [], tip, children }) {
  const { pathname } = useLocation();
  const isCurrent = (target) => {
    if (target === VHU_LOTS_PAGE) {
      return pathname === VHU_LOTS_PAGE || pathname.startsWith(`${VHU_LOTS_PAGE}/`);
    }
    return pathname === target;
  };

  return (
    <section className="vhu-page-guide" aria-labelledby="vhu-guide-title">
      <nav className="vhu-workspace-nav" aria-label="Navigation du module VHU">
        {navigationItems.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`vhu-workspace-link${isCurrent(item.to) ? " active" : ""}`}
          >
            <i className={item.icon} />
            <span><strong>{item.label}</strong><small>{item.hint}</small></span>
          </Link>
        ))}
      </nav>

      <div className="vhu-guide-body">
        <div className="vhu-guide-copy">
          <span className="vhu-guide-eyebrow">{eyebrow}</span>
          <h2 id="vhu-guide-title">{title}</h2>
          <p>{description}</p>
          {tip && <div className="vhu-guide-tip"><i className="ri-lightbulb-flash-line" /><span>{tip}</span></div>}
        </div>
        {!!steps.length && (
          <ol className="vhu-guide-steps">
            {steps.map((step, index) => (
              <li key={step.title}>
                <span>{index + 1}</span>
                <div><strong>{step.title}</strong><small>{step.text}</small></div>
              </li>
            ))}
          </ol>
        )}
        {children && <div className="vhu-guide-actions">{children}</div>}
      </div>
    </section>
  );
}

export default VhuPageGuide;
